// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CopyLinkController from "./copy_link_controller"
application.register("copy-link", CopyLinkController)

import GhlSessionController from "./ghl_session_controller"
application.register("ghl-session", GhlSessionController)

import RecorderController from "./recorder_controller"
application.register("recorder", RecorderController)

import TranscriptController from "./transcript_controller"
application.register("transcript", TranscriptController)

import WatchStatusController from "./watch_status_controller"
application.register("watch-status", WatchStatusController)
